export const NO_LIMIT_MAX_KITS = 2147483646;